import React from 'react';
import { LegacyKickstarterRedirect } from '~/components/common';

const VendorAuthorizationRoot = () => (
  <LegacyKickstarterRedirect hash="/api-key" />
);

export default VendorAuthorizationRoot;
